import React from 'react';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-[#FDFAF7] border-y border-[#E2E8F0] text-center" data-id="element-97">
      <div className="max-w-[600px] mx-auto" data-id="element-98">
        <div className="inline-flex items-center justify-center p-4 bg-[#EEF2F7] rounded-full mb-6 border border-[#1B3A6B]/10" data-id="element-99">
          <Shield className="w-10 h-10 text-[#1B3A6B]" data-id="element-100" />
        </div>

        <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#1C1C2E] mb-2" data-id="element-101">
          Garantía Incondicional de 30 Días
        </h2>
        <h3 className="text-[#1B3A6B] font-bold text-lg mb-6 uppercase tracking-wide flex items-center justify-center gap-2" data-id="element-102">
          <Shield className="w-5 h-5" data-id="element-103" /> 100% LIBRE DE RIESGO
        </h3>

        <div className="bg-white p-8 rounded-xl border border-[#E2E8F0] text-left space-y-4 mb-8 shadow-sm" data-id="element-104">
          <p className="text-[#4A4A6A]" data-id="element-105">
            Lee la guía. Usa las herramientas. Aplica el protocolo en tu
            familia.
          </p>
          <p className="text-[#1C1C2E] font-bold text-lg" data-id="element-106">
            Si sientes que no te dio ninguna herramienta nueva, ninguna
            claridad, ningún alivio — te devuelvo cada centavo.
          </p>
          <p className="text-[#4A4A6A]" data-id="element-107">
            Sin preguntas. Sin formularios. Sin demoras.
          </p>

          <div className="bg-[#FDF0F3] p-4 rounded-lg border-l-4 border-[#B83A52] mt-4" data-id="element-108">
            <p className="text-[#B83A52] font-medium italic" data-id="element-109">
              "Porque si no te sirve a ti en este momento tan importante, no
              merece tu dinero."
            </p>
          </div>
        </div>
      </div>
    </section>;
}